import { useReactFlow } from 'reactflow'

export function useNodeLocateByName() {
  const { setViewport, getNodes } = useReactFlow()

  const locateNode = (nodeName: string) => {
    const nodes = getNodes()
    const targetViewPortNode = nodes.find(n => n.data.name === nodeName)
    if (targetViewPortNode) {
      setViewport({
        x:
          document.body.clientWidth / 2 -
          (targetViewPortNode.width || 0) / 2 -
          targetViewPortNode.position.x,
        y: (targetViewPortNode.height || 0) / 2 - targetViewPortNode.position.y,
        zoom: 1,
      })
    }
  }

  return {
    locateNode,
  }
}
